import { Component, Input } from '@angular/core';
import { EventBusService } from '../../../../services/event-bus.service';
import { ReportDesignerWidgetConfig } from '../../models/report-designer-widget-config';

/**
 * Infobar comment component
 */
@Component({
  selector: 'widget-infobar-comment',
  templateUrl: './widget-infobar-comment.component.html'
})
export class WidgetInfobarCommentComponent {
  /**
   * Widget config
   */
  @Input() widgetConfig: ReportDesignerWidgetConfig;

  /**
   * Comment is empty?
   */
  public emptyComment = false;

  /**
   * Constructor
   * @param eventBus EventBusService
   */
  constructor(private eventBus: EventBusService) { }

  /**
   * Comment was changed?
   */
  public changeComment(): void {
    if (this.widgetConfig.comment) {
      this.emptyComment = false;
    }
    else {
      this.emptyComment = true;
    }
    this.eventBus.broadcastEvent('commentButtonRed', this);
  }
}
